import type {
    ComponentStageData,
    ComponentStageHandlerResults,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry,
    PluginStageHandler
} from '../../types'
import {heightHeuristics, verticalSpacingHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic, findHeuristic} from '../common'
import {rowHeuristicsFlush, rowHeuristicsAdaptive} from './rowHeuristicsDefinitions'

export const createPlugin = ({stages, readOnlyExtensionAPI}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const calculateVerticalSpacing: PluginStageHandler<ComponentStageData> = (
        componentStageData: ComponentStageData
    ) => {
        const heuristicToApply = findHeuristic(verticalSpacingHeuristics, componentStageData)
        heuristicToApply.apply(componentStageData)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const calculateHeight: PluginStageHandler<ComponentStageData> = (
        componentStageData: ComponentStageData
    ): ComponentStageHandlerResults => {
        const heuristicToApply = findHeuristic(heightHeuristics, componentStageData, undefined, readOnlyExtensionAPI)
        heuristicToApply.apply(componentStageData, undefined, readOnlyExtensionAPI)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const setContainerRows: PluginStageHandler<ComponentStageData> = (componentStageData: ComponentStageData) => {
        const heuristicToApply = findHeuristic(rowHeuristicsFlush, componentStageData, undefined, readOnlyExtensionAPI)

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData, undefined, readOnlyExtensionAPI)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const setContainerRowsAdaptive: PluginStageHandler<ComponentStageData> = (
        componentStageData: ComponentStageData
    ) => {
        const heuristicToApply = findHeuristic(
            rowHeuristicsAdaptive,
            componentStageData,
            undefined,
            readOnlyExtensionAPI
        )

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData, undefined, readOnlyExtensionAPI)

        return {appliedHeuristics: [heuristicToApply.heuristicCode]}
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.VERTICAL_LAYOUT_SCALE, createAdaptiveHeuristic(calculateHeight))
        registry.register(stages.VERTICAL_LAYOUT_SCALE, createAdaptiveHeuristic(calculateVerticalSpacing))
        registry.register(
            stages.VERTICAL_LAYOUT_SCALE,
            createAdaptiveHeuristic(setContainerRows, setContainerRowsAdaptive)
        )
    }

    const name = 'verticalScaleAndSize'
    return {register, name, dependencies: ['horizontalScaleAndSize', 'order']}
}
